var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-component"},[_c('el-checkbox',{attrs:{"value":_vm.values,"label":_vm.value}},[_c('span')]),_c('div',{staticClass:"click-box",on:{"click":_vm._toggleItem}}),(!_vm.isEmptyObject(_vm.$slots) || _vm.text)?_c('label',{staticClass:"checkbox-text"},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }